import React from 'react'
import { SCHOOL_TYPE_FLAGS } from '../../app/constants/flags'
import { getLang } from '../../app/selectors/lang'
import SedaFlagGroup from './SedaFlagGroup'

/**
 * Displays a button group of school type filters that can be
 * toggled on and off.
 */
const SedaSchoolType = ({ region, ...props }) => {
  // flags to toggle in this button group
  const flags = SCHOOL_TYPE_FLAGS
  // are groups are only available for schools
  const isDisabled = region !== 'schools'
  // text when disabled: These filters are only available in {{regions}} view.
  const tooltipText =
    isDisabled &&
    getLang('TOOLTIP_HINT_REGION_FILTER', {
      regions: 'schools'
    })

  return (
    <SedaFlagGroup
      tooltip={tooltipText}
      disabled={isDisabled}
      flags={flags}
      {...props}
    />
  )
}

export default SedaSchoolType
